var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueEditor',{attrs:{"value":_vm.value,"editorToolbar":_vm.customizeToolbar},on:{"input":_vm.updateContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }